<template lang="pug">
  v-card.mt-3(outlined)
    v-card-title App Settings

    v-divider

    v-card-text
      v-row(align='center', justify='center')
        v-col(cols='12', sm='10', md='8', lg='6', xl='4')
          v-text-field(
            v-model='token',
            label='Access Token',
            ref='accessToken',
            hint='This token is used by the studio to retrieve this app\'s configuration',
            persistent-hint,
            readonly,
            disabled,
            :loading='loading',
            type='text'
          )
            template(v-slot:prepend, v-if='!token && !loading')
              v-tooltip(bottom)
                template(v-slot:activator='{ on }')
                  v-icon(large, @click='generateAccessToken', v-on='on') {{ icons.mdiRefresh }}
                span Generate Token

            template(v-slot:append)
              v-icon(@click='copyText(token)') {{ icons.mdiContentCopy }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mdiRefresh, mdiContentCopy } from '@mdi/js'

import copyText from '@/mixins/copyText'

export default {
  name: 'Settings',

  mixins: [copyText],

  async mounted () {
    this.token = await this.retrieveAccessToken(this.app.id)
    this.loading = false
  },

  data () {
    return {
      token: null,
      loading: true,

      icons: { mdiRefresh, mdiContentCopy }
    }
  },

  computed: {
    ...mapGetters('apps', ['app'])
  },

  methods: {
    ...mapActions('vsauce', ['retrieveAccessToken', 'createAccessToken']),

    async generateAccessToken () {
      this.loading = true
      this.token = await this.createAccessToken(this.app.id) || await this.retrieveAccessToken(this.app.id)
      this.loading = false
    }
  }
}
</script>
